import { useEffect, useState } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import { ALIGN, ButtonsContent, ILandingSection } from "src/modules/pe-landing-module/data/interfaces"
import { ButtonsPrimitive } from "../primitive"
import { setHorizontalAlignToCSSRule, setVerticalAlignToCSSRule } from "../section/Section"
import Dummy from "./Dummy"
import DataContentEditor from "../landing-edit/editors/data-content-editor"


/* Protopia Ecosystem component */
export interface IButtonsProps {
    section: ILandingSection
    data: ButtonsContent 
}
const Buttons = ({data, section, ...props}: IButtonsProps): JSX.Element => {
    const [width]           = useState<string>(getCssDemention( data.width, "100%" ))
    const [height, ]        = useState<string>(getCssDemention( data.height, "fit-content" ))
    const horizontalAlign   = useState<string>( setHorizontalAlignToCSSRule( data?.horizontal_align ||ALIGN.MIDDLE) )
    const vertical_align   = useState<string>( setVerticalAlignToCSSRule( data?.vertical_align ||ALIGN.MIDDLE) )
    useEffect(() => {
        addCSSClass(
            `landing-buttons-${section.id}`,
            `.landing-buttons-${section.id} { 
                max-width: ${ width };
                max-height: ${ height };
                width: ${ width };
                height: ${ height };
                ${horizontalAlign}
                ${vertical_align}
                z-index:1;
            } 
            `
        )
        return () => {
            removeCSSClass(`landing-buttons-${section.id}`)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[  ])
    
    return true
        ?
        <div className={`landing-buttons-container landing-content-container`} data-type={data.type} data-content-id={data.id}>
            <div className={`landing-buttons landing-buttons-${ section.id } ${ data.className || "" } `} >
                <ButtonsPrimitive primitive={{ ...data as any }} />
            </div>
            <DataContentEditor data={data}  section={section} />
        </div>
        :
        <Dummy {...{ 
            ...{
                data: {
                    ...data,
                    className: ` ${data.className} landing-buttons-${ section.id } `
                },
            }, 
            ...props 
        }} />
}
export default Buttons